import React,{ useState } from 'react';
import {
  Link , useParams , Navigate , useNavigate, 
} from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const getInitials = (name) => (name || '')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((word) => word[0])
  .join('')
  .toUpperCase();

const logoClass = 'h-20 w-20 shrink-0 rounded-2xl bg-white shadow-md ring-1 ring-black/5';

function ResetpasswordPage({ baseURL }) {
  const { userId,tokenId } = useParams();
  const navigate = useNavigate();
  const [newpassword,setNewPassword] = useState('');
  const [NewconfirmPassword,setNewConfirmPassword] = useState('');
  // Fall back to company initials when the logo fails to load
  const [logoFailed, setLogoFailed] = useState(false);
  
  const SubmitHandler = async () => {
    if (newpassword !== NewconfirmPassword) {
      toast.error('Password dosenot match');
    } else {
      if (newpassword.length < 5) {
        toast.error('Enter Strong Password');
        return;
      }
      const putbody = {
        password: newpassword,
        retype_new_password: NewconfirmPassword,
      };
      const response = await axios.post(`${baseURL}/user/forget-password/${tokenId}/${userId}`,putbody);
      // console.log(response,'this is response');
      if (response.data.status === 'success') {
        toast.success(response.data.message);
        setNewPassword('');
        setNewConfirmPassword('');
        setTimeout(() => {
          window.location.href = `https://app.salescaptain.com/login`;
        },[1000]);
      }
      if (response.data.status === 'failure') {
        toast.error(response.data.message);
      }
    }
  };
  return (
    <div className="qs-page flex-col items-center">
      <div className="qs-card max-w-[420px]">
        <div className="qs-card-body space-y-5">
          <div className="flex justify-center">
            {!logoFailed ? (
              <img
                src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'}
                alt="logo not found"
                className={`${logoClass} object-contain p-1`}
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <div className={`${logoClass} flex items-center justify-center text-xl font-medium text-slate-600`}>
                {getInitials(localStorage.getItem('h_name') ?? 'SalesCaptain')}
              </div>
            )}
          </div>
          <div className="flex justify-center">
            <h3 className="qs-title">Reset Password</h3>
          </div>
          <div>
            <input 
              placeholder="New password"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newpassword}
              className="qs-input"
            />
          </div>
          <div>
            <input 
              placeholder="Confirm New Password "
              onChange={(e) => setNewConfirmPassword(e.target.value)}
              value={NewconfirmPassword}
              className="qs-input"
            />
          </div>
          <button
            type="button"
            className="qs-btn qs-btn-primary"
            onClick={SubmitHandler}
          >
            Change password
          </button>
        </div>
      </div>
      <div className="mt-6 flex flex-row items-center justify-center gap-2">
        <span className="flex items-center gap-2 self-center text-xs text-slate-400">
          Powered by 
          <img className="h-[17px]" src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} alt="" />
          {localStorage.getItem('h_name') ?? 'SalesCaptain'}
        </span>
      </div>
    </div>
  );
}

export default ResetpasswordPage;
